module.exports = __webpack_public_path__ + "img/hfdg.66e377fb.jpg";